var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "v-popup-formation-cycle"
  }, [_c('div', {
    staticClass: "v-popup__header"
  }, [_vm._m(0), _c('a', {
    on: {
      "click": _vm.close
    }
  }, [_vm._m(1)])]), _c('div', {
    staticClass: "v-popup__content"
  }, [_c('div', {
    staticClass: "v-popup-layout"
  }, [_c('div', {
    staticClass: "v-popup-layout__left-panel",
    style: {
      width: _vm.leftPanelExpanded ? '250px' : '60px'
    }
  }, [_c('div', {
    staticClass: "v-popup-accordion-header",
    on: {
      "click": _vm.toggleLeftPanel
    }
  }, [_c('span', [_vm._v("고유 ID")]), _c('span', {
    staticClass: "v-popup-accordion__arrow",
    style: {
      transform: _vm.leftPanelExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
    }
  }, [_vm._v("▼")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.leftPanelExpanded,
      expression: "leftPanelExpanded"
    }],
    staticClass: "v-popup-left-panel__content-wrapper"
  }, [_c('div', {
    staticClass: "v-popup-left-panel__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchKeyword,
      expression: "searchKeyword"
    }],
    staticClass: "v-popup__input",
    attrs: {
      "type": "text",
      "placeholder": "ID 검색..."
    },
    domProps: {
      "value": _vm.searchKeyword
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.searchKeyword = $event.target.value;
      }, _vm.searchIds]
    }
  }), _c('label', {
    staticClass: "v-popup__checkbox-label"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isAllSelected
    },
    on: {
      "change": _vm.toggleSelectAll
    }
  }), _c('span', [_vm._v("전체선택")]), _c('button', {
    staticClass: "v-popup-refresh-btn",
    attrs: {
      "title": "새로고침"
    },
    on: {
      "click": _vm.refreshIdList
    }
  }, [_vm._v(" ↺ ")])])]), _c('div', {
    staticClass: "v-popup-left-panel__list"
  }, [_c('HotTableMain', {
    ref: "idListHotRef",
    attrs: {
      "settings": _vm.idListHotSettings
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedIds.length > 0,
      expression: "selectedIds.length > 0"
    }],
    staticClass: "v-popup-left-panel__footer"
  }, [_c('a', {
    staticClass: "btn_type1",
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    on: {
      "click": _vm.applySelection
    }
  }, [_vm._v(" 적용 (" + _vm._s(_vm.selectedIds.length) + "건) ")])])])]), _c('div', {
    staticClass: "v-popup-layout__right-panel"
  }, [_c('div', {
    staticClass: "v-popup-right-panel__top"
  }, [_c('div', {
    ref: "analysisScrollContainer",
    staticClass: "v-popup-analysis-scroll-container"
  }, [_vm.analysisColumns.length > 0 ? _c('div', {
    staticClass: "v-popup-analysis-container"
  }, _vm._l(_vm.analysisColumns, function (column) {
    return _c('div', {
      key: column.key,
      staticClass: "v-popup-analysis-card",
      class: {
        'is-highlighted': _vm.selectedColumnKey === column.key
      },
      on: {
        "click": function ($event) {
          return _vm.selectColumn(column);
        }
      }
    }, [_c('div', {
      staticClass: "v-popup-analysis-card__title"
    }, [_vm._v(_vm._s(column.label))]), _c('div', {
      staticClass: "v-popup-analysis-card__options"
    }, [_c('div', {
      staticClass: "v-popup-analysis-controls"
    }, [_c('div', {
      staticClass: "v-popup-radio-group"
    }, _vm._l(column.analysisOptions, function (option) {
      return _c('label', {
        key: option.value,
        staticClass: "v-popup__radio-label"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.columnAnalysisSelections[column.key],
          expression: "columnAnalysisSelections[column.key]"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.value,
          "checked": option.checked,
          "checked": _vm._q(_vm.columnAnalysisSelections[column.key], option.value)
        },
        on: {
          "change": function ($event) {
            return _vm.$set(_vm.columnAnalysisSelections, column.key, option.value);
          }
        }
      }), _vm._v(" " + _vm._s(option.text) + " ")]);
    }), 0), _c('a', {
      staticClass: "v-popup-chart-btn",
      on: {
        "click": function ($event) {
          _vm.openChartPopup(column, column.analysisOptions.find(function (o) {
            return o.value === _vm.columnAnalysisSelections[column.key];
          }));
        },
        "mouseover": function ($event) {
          _vm.showChartPreview($event, column, column.analysisOptions.find(function (o) {
            return o.value === _vm.columnAnalysisSelections[column.key];
          }));
        },
        "mouseleave": _vm.hideChartPreview
      }
    }, [_vm._v(" 차트 보기 ")])])]), _c('div', {
      staticClass: "v-popup-analysis-card__results"
    }, _vm._l(_vm.currentAnalysisResults[column.key], function (result, index) {
      return _c('div', {
        key: index,
        staticClass: "v-popup-result-item",
        class: `is-style-${_vm.columnAnalysisSelections[column.key]}`
      }, [_vm._v(" " + _vm._s(result) + " ")]);
    }), 0)]);
  }), 0) : !_vm.loading ? _c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("노드에 입력된 데이터가 존재하지 않습니다.")])]) : _vm._e()])]), _c('div', {
    staticClass: "v-popup-right-panel__bottom"
  }, [_c('HotTableMain', {
    ref: "handsomeRef",
    attrs: {
      "settings": _vm.hotSettings
    }
  })], 1)])])]), _c('div', {
    staticClass: "v-popup__footer"
  }, [_c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.downloadExcel
    }
  }, [_vm._v("Excel 다운로드")]), _c('a', {
    staticClass: "btn_type2",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "v-popup-mask",
    on: {
      "click": _vm.close
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  }), _c('ChartPopup', {
    attrs: {
      "visible": _vm.chartPopup.visible,
      "title": _vm.chartPopup.title,
      "chart-data": _vm.chartPopup.chartData,
      "type": _vm.chartPopup.type
    },
    on: {
      "close": _vm.closeChartPopup
    }
  }), _vm.chartPreview.visible ? _c('div', {
    staticClass: "v-popup-chart-preview",
    style: {
      top: `${_vm.chartPreview.position.top}px`,
      left: `${_vm.chartPreview.position.left}px`
    }
  }, [_c('Bar', {
    attrs: {
      "chart-data": _vm.chartPreview.data,
      "options": {
        responsive: true,
        plugins: {
          legend: {
            display: false
          }
        }
      }
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', [_vm._v("데이터 상세 분석")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "v-popup__close-btn",
    attrs: {
      "title": "Close"
    }
  }, [_c('div', {
    staticClass: "v-popup__close-box"
  }, [_c('span'), _c('span')])]);

}]

export { render, staticRenderFns }